import cx from "classnames";

import { CloudProps } from "./types";

import styles from "./styles.module.css";

export function Component<CloudItemProps>(props: CloudProps<CloudItemProps>) {
  const {
    IterableComponent,
    componentPropsList,
  } = props;

  if (!IterableComponent) {
    console.error("No IterableComponent found for Cloud");

    return null;
  }

  if (!componentPropsList?.length) {
    console.error(`No props passed in for components in Cloud`);

    return null;
  }


  const iterableComponents = componentPropsList.map((componentProp) => (
    <IterableComponent {...componentProp} />
  ));

  return (
    <div
      className={cx([
        styles.cloudContainer,
      ])}
    >
      {componentPropsList
        .map((_, itemIndex) => (
            iterableComponents[itemIndex]
        ))}
    </div>
  );
}
Component.displayName = "Cloud.Component";
